"use client";

import { Box, Text } from "@chakra-ui/react";

export default function ProgressLike({
  percent,
  trackColor = "#D1D4D9", // 회색 트랙
  barColor = "#9050FF", // 보라색 바
}) {
  const clamped = Math.max(0, Math.min(100, Math.floor(percent)));

  return (
    <Box
      position="relative"
      w="100%"
      h="20px"
      bg={trackColor}
      rounded="full"
      overflow="hidden"
    >
      {/* Progress fill */}
      <Box
        position="absolute"
        left={0}
        top={0}
        h="100%"
        w={`${clamped}%`}
        bg={barColor}
        rounded="full"
        transition="width 0.25s ease"
        // 얇고 진한 stroke 느낌 (퍼짐 최소화)
        boxShadow={`0 0 2px 1px ${barColor}`}
      />

      {/* 퍼센트 텍스트 */}
      <Text
        position="absolute"
        left="50%"
        top="50%"
        transform="translate(-50%, -50%)"
        color="#FDFEFE"
        fontSize="10px"
        fontFamily="Pretendard, sans-serif"
        fontWeight="700"
        lineHeight="10px"
        textAlign="center"
        whiteSpace="nowrap"
        userSelect="none"
        // 텍스트에도 미세한 stroke 강조
        textShadow={`0 0 2px ${barColor}, 0 0 1px ${barColor}`}
      >
        {clamped}%
      </Text>
    </Box>
  );
}
